import { getProperty } from "../functions/get-property";

/**
 * Formats a string with supplied data properties.
 * @param formatString The format string e.g. Please format me with a {value}.
 * @param data The object data to use for formatting.
 * @returns Formatted data string.
 */
export function dataFormat(formatString: string, data: object) {

	if (!formatString) return "";
	if (formatString.indexOf('{') == -1 || formatString.indexOf('}') == -1) return formatString;

	let outputString = formatString;
	let matches = formatString.match(/{(.*?)}/g);

	if (matches !== null) {

		matches.forEach((val) => {

			let field = val.replace(/{/g, '').replace(/}/, ''),
				value = getProperty(data, field);

			outputString = outputString.replace(val, value ? value : '');
		});
	}

	return outputString;
}

/**
 * Formats a URL string with supplied data properties.
 * @param formatString The format string e.g. /item/(id).
 * @param data The object data to use for formatting.
 * @returns Formatted URL string.
 */
export function urlDataFormat(formatString: string, data: object) {

	if (!formatString) return "";
	if (formatString.indexOf('(') == -1 || formatString.indexOf(')') == -1) return formatString;

	let outputString = formatString;
	let matches = formatString.match(/\((.*?)\)/g);

	if (matches !== null) {

		matches.forEach(function (val) {

			let field = val.replace(/\(/g, "").replace(/\)/, ""),
				value = getProperty(data, field),
				encodedValue = value ? encodeURIComponent(value) : "";

			outputString = outputString.replace(val, encodedValue);
		});
	}

	return outputString;
}

/**
 * Adds a CSS class to a string.
 * @param cssClasses The string to add the CSS class to.
 * @param cssClass The CSS class to add.
 * @returns The appended string.
 */
export function addClass(cssClasses: string, cssClass: string) {

	if (cssClasses) {
		cssClasses += " ";
		cssClasses += cssClass;
	}
	else {
		cssClasses = cssClass;
	}
	return cssClasses;
}